export const isBuild = (): boolean => process.env.NODE_ENV === 'production';
